module.exports = __webpack_public_path__ + "img/sprite.e22ab0f8.svg";